document.addEventListener('turbo:load', function() {
  
  /* --------------------------------------------------
                Guides Modal
  -------------------------------------------------- */
  const pagesGuidesModal = function() {
    const videoModal = document.getElementById('modal-guides-modal');
    if (!videoModal) return;

    const videoContainer = document.getElementById('guides-video-container');
    const videoListContainer = document.getElementById('guides-video-list-container');
    const videoTemplate = document.getElementById('guides-video-template');
    const videoItems = Array.from(videoModal.querySelectorAll('[id^="guides-video-item-"]'));

    // Scroll the item into view
    const scrollItemIntoView = (item) => {
      const container = videoListContainer;
      if (!container || !item) return;
      const itemRect = item.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      if (itemRect.top < containerRect.top) {
        container.scrollTop -= (containerRect.top - itemRect.top);
      } else if (itemRect.bottom > containerRect.bottom) {
        container.scrollTop += (itemRect.bottom - containerRect.bottom);
      }
    };

    // Update the active item
    const updateActiveItem = (currentItem) => {
      videoItems.forEach(item => {
        item.classList.remove('bg-theme-highlight-50');
        item.classList.add('hover:bg-gray-100');
      });
      currentItem.classList.add('bg-theme-highlight-50');
      currentItem.classList.remove('hover:bg-gray-100');
    };

    // Update the video player
    const updateVideoPlayer = (videoUrl) => {
      if (!videoUrl) {
        videoContainer.innerHTML = '';
        return;
      }
      const content = videoTemplate.content.cloneNode(true);
      const video = content.querySelector('video');
      video.src = videoUrl;
      videoContainer.innerHTML = '';
      videoContainer.appendChild(content);
    };

    // Show the modal
    const showModal = () => {
      if (videoModal.classList.contains('hidden')) {
        document.body.style.overflow = 'hidden';
        videoModal.classList.remove('hidden');
        videoModal.setAttribute('aria-hidden', 'false');
      }
    };

    // Update the URL
    const updateUrl = (newVideoId) => {
      const url = new URL(window.location);
      url.searchParams.set('video', newVideoId);
      history.pushState({}, '', url);
    };

    // Select the video
    const selectVideo = (item, options = { updateUrl: false, showModal: false, useTimeout: false }) => {
      if (!item) return;

      updateActiveItem(item);
      updateVideoPlayer(item.dataset.videoUrl);

      if (options.updateUrl) {
        const videoId = item.id.replace('guides-video-item-', '');
        updateUrl(videoId);
      }
      if (options.showModal) {
        showModal();
      }
      
      if (options.useTimeout) {
        setTimeout(() => scrollItemIntoView(item), 100);
      } else {
        scrollItemIntoView(item);
      }
    };

    // Initialize the player
    const initializePlayer = () => {
      const url = new URL(window.location);
      const videoParam = url.searchParams.get('video');
      let videoToShow = null;
      let shouldShowModal = false;

      if (videoParam) {
        videoToShow = videoModal.querySelector(`#guides-video-item-${videoParam}`);
        if (videoToShow) {
          shouldShowModal = true;
        }
      }

      if (!videoToShow && videoItems.length > 0) {
        videoToShow = videoItems[0];
      }

      if (videoToShow) {
        selectVideo(videoToShow, { 
          showModal: shouldShowModal, 
          useTimeout: shouldShowModal 
        });
      }
    };

    // Add event listeners to the video items
    videoItems.forEach(item => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        selectVideo(item, { updateUrl: true });
      });
    });

    // Initialize the player
    initializePlayer();
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pagesGuidesModal();
});
